import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import ForumIcon from '@mui/icons-material/Forum';

import api from '../../api';
import { URL } from '../../utils/constants/general';
import { useStyles } from './styles';
import Link from '../../components/Link';

const Footer = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const [appVersion, setAppVersion] = useState(0);

	useEffect(() => {
		api.getAppVersion().then(data => {
			setAppVersion(data);
		});
	}, []);

	return (
		<Box
			display="flex"
			justifyContent="center"
			order={{
				xs: 1,
				sm: 1,
				md: 2,
				lg: 2,
				xl: 2
			}}
			className={classes.rootContainer}>
			<Typography>
				<ForumIcon fontSize="small" className={classes.contactIcon} />
			</Typography>

			<Typography variant="subtitle1" className={classes.emailLink}>
				<Link variant="subtitle1" href={URL.COMMUNITY_FORUM} target="_blank" underline="none">
					{t('general.communityForum')}
				</Link>
			</Typography>

			<Typography variant="subtitle1" className={classes.emailLink}>
				|
			</Typography>

			<Typography variant="subtitle1" className={classes.version}>
				{appVersion}
			</Typography>
		</Box>
	);
};

export default Footer;
